import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { appConstants } from 'src/app/shared/constants/app.constants';
import { AdobeAnalyticsService } from "src/app/shared/services/common/adobeAnalytics.service";

@Component({
  selector: 'app-error500',
  templateUrl: './error500.component.html',
  styleUrls: ['./error500.component.scss']
})
export class Error500Component implements OnInit {

  autoRedirectTime : number = 10;

  constructor(private pageTitle: Title, private meta: Meta, private router: Router, public adobeAnalyticsService: AdobeAnalyticsService) { }

  ngOnInit() {
    this.pageTitle.setTitle(appConstants.baseTitle);
    window.scrollTo(0, 0);
    let internalSub = setInterval(() => {
      if (this.autoRedirectTime >=1) {
        this.autoRedirectTime -= 1;
      }else{
        window.location.href = '/';
      }
    }, 1000);

    this.meta.addTag({ rel: 'canonical', href: appConstants.canonicalUrl + this.router.url });
    this.adobeAnalyticsService.loadDataLayerScript({
      siteSection1: "Info Page",
      siteSection2: "Error Page",
      pageName: "500 Page", 
      contentType: "Error - 500",
    });
  }
}
